import { render } from "./SchoolInitiativeForm.vue?vue&type=template&id=29d08012&scoped=true"
import script from "./SchoolInitiativeForm.vue?vue&type=script&lang=js"
export * from "./SchoolInitiativeForm.vue?vue&type=script&lang=js"

import "./SchoolInitiativeForm.vue?vue&type=style&index=0&id=29d08012&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29d08012"]])

export default __exports__